module.exports = __webpack_public_path__ + "static/media/tt_norms_bold.b99708b9.otf";